import VerificarUsuario from "../../helpers/usuario/verificarUsuario";
import campoExclusivoNumeros from "../../helpers/datos/campoExclusivoNumeros";

/**
 * Componente de contacto del contribuyente
 * @param {Object} param0 
 * @returns Componente React
 */
export default function ContactoContacto({ data, setData }) {

    VerificarUsuario();
    let direccion;
    const { contribuyente, direcciones } = data;
    direcciones === undefined ? direccion = {} : [direccion] = direcciones;

    return (
        <div id="contacto" className="tabcontent">
            <div className="formulario">
                <div className="boxRow">
                    {/* Teléfono */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Télefono</label>
                        <div className="search-bar">
                            <div className="actions noActions">
                                <button><span className="material-icons">phone</span></button>
                            </div>
                            <input className="iconLeft" type="text" maxLength="25"
                                value={direccion?.telefono === undefined ? "" : direccion.telefono}
                                onChange={e => campoExclusivoNumeros(e.target.value, data, setData)}
                            />
                        </div>
                    </div>

                    {/* Email */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Email</label>
                        <div className="search-bar">
                            <div className="actions noActions">
                                <button><span className="material-icons">email</span></button>
                            </div>
                            <input className="iconLeft" type="text"
                                value={contribuyente?.mail === undefined ? "" : contribuyente?.mail}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, mail: e.target.value.toUpperCase() } })}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
